import { vnTemplate } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { filterSingle_multiLevel_selector_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template';
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import { vnApp_sentinelbi } from '../vnApp_sentinelbi';

declare var ko: any;


export class brandDashboard_template extends vnTemplate {

    protected brandFilter: filterSingle_multiLevel_selector_template;
    protected dateRangeFilter: filterDate_template;
    protected presetFilter: presetFilter_template;
    protected metricFilter: filterSingle_multiLevel_selector_template;
    protected dimensionFilter: filterSingle_multiLevel_selector_template;

    readonly metricValues = [
        {"id": "views", "name": "Views"},
        {"id": "visits", "name": "Visits"},
        {"id": "sessions", "name": "Sessions"},
    ];

    readonly dimensionValues = [
        {"id": "source", "name": "Source"},
        {"id": "device", "name": "Device"},
        {"id": "geo", "name": "Geo"},
        {"id": "browser", "name": "Browser"},
        {"id": "os", "name": "OS"},
    ];

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        return `
            <div id="report-results">

                <div class="page-header">
                    <button data-bind="click: toggleOpenReportFilters" class="button-default mobile-filters icon i-filters report-filters-btn-js-only" type="button"></button>
                    <h2 class="title-page">Brand Dashboard</h2>
                </div>

                <div class="w-justify block-filters side-block-filters" data-bind="css: isReportFiltersOpen() ? 'is-open' : ''"> <!-- is-open -->
                    <div class="w-right flex-all block-default report-filters-js-only">
                        <div class="w-justify full-width">
                            <div class="w-left">
                                <div class="sidebar-default-header">
                                    <span class="label-default sidebar-default-header icon i-filters">Filters</span>
                                    <button data-bind="click: toggleOpenReportFilters" type="button" class="btn-close-default icon i-close"><span></span></button>
                                </div>
                                <div class="w-brand-filter">
                                    ${this.brandFilter.getHtmlBuild()}
                                </div>

                                <div class="w-range-compare mobile-hidden">
                                    ${this.dateRangeFilter.getHtmlBuild()}
                                </div>
                                <div class="switch-field mobile-only">
                                    <div class="w-input">
                                        <input type="radio" id="radio-week" name="mobile-date-switch-indicators" value="last-week" data-bind="event: {change: onMobileDateBtnSwitch.bind($data, 'last-week')}, checked: mobileDateBtnSwitch"/>
                                        <label for="radio-week">Last week</label>
                                        <input type="radio" id="radio-yest" name="mobile-date-switch-indicators" value="yesterday" data-bind="event: {change: onMobileDateBtnSwitch.bind($data, 'yesterday')}, checked: mobileDateBtnSwitch"/>
                                        <label for="radio-yest">Yest.</label>
                                        <input type="radio" id="radio-wtd" name="mobile-date-switch-indicators" value="wtd" data-bind="event: {change: onMobileDateBtnSwitch.bind($data, 'wtd')}, checked: mobileDateBtnSwitch"/>
                                        <label for="radio-wtd">WTD</label>
                                        <input type="radio" id="radio-mtd" name="mobile-date-switch-indicators" value="mtd" data-bind="event: {change: onMobileDateBtnSwitch.bind($data, 'mtd')}, checked: mobileDateBtnSwitch"/>
                                        <label for="radio-mtd">MTD</label>
                                    </div>
                                </div>
                            </div>

                            <div class="w-right">

                            </div>

                        </div>
                    </div>

                </div>

                <div class="w-brand-dashboard">
                    <div class=" w-card-table">

                        <div class="section-overview card-overview">
                            <div class="card-group">
                                <div class="card-header">
                                    <h2 class="title-card">Overview</h2>
                                </div>
                                <div class="card-body">
                                    <!-- ko with: overviewData(), as: 'overviewData'  -->
                                        <div class="card-row">
                                            <div class="ov-card">
                                                <span class="card-label">Sessions</span>
                                                <span class="card-value" data-bind="text: Number(overviewData.sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                            </div>
                                            <div class="ov-card">
                                                <span class="card-label">PG/S</span>
                                                <span class="card-value" data-bind="text: Number(overviewData.viewsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                            </div>
                                        </div>
                                        <div class="card-row">
                                            <div class="ov-card">
                                                <span class="card-label">Views</span>
                                                <span class="card-value" data-bind="text: Number(overviewData.views).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                            </div>
                                            <div class="ov-card">
                                                <span class="card-label">Visits</span>
                                                <span class="card-value" data-bind="text: Number(overviewData.visits).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                            </div>
                                        </div>
                                        <div class="card-row card-row-3">
                                            <div class="ov-card">
                                                <span class="card-label">AVG SPEED</span>
                                                <span class="card-value" data-bind="text: Number(overviewData.avgConnectionSpeed).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                            </div>
                                            <div class="ov-card">
                                                <span class="card-label">Scroll Depth %</span>
                                                <span class="card-value" data-bind="text: Number(overviewData.avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                            </div>
                                            <div class="ov-card">
                                                <span class="card-label">AVD (MM:SS)</span>
                                                <span class="card-value" data-bind="text: overviewData.avgViewEngagedSeconds"></span>
                                            </div>
                                        </div>
                                    <!-- /ko -->
                                </div>
                            </div>


                            <div class="card-group">
                                <div class="card-header">
                                    <h2 class="title-card">Logged-in</h2>
                                </div>
                                <div class="card-body">
                                    <!-- ko with: overviewData(), as: 'overviewData'  -->
                                        <div class="card-row">
                                            <div class="ov-card highlight">
                                                <span class="card-label">Sessions</span>
                                                <span class="card-value" data-bind="text: overviewData.sessionsLoggedInPercentage ? Number(overviewData.sessionsLoggedInPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : 0.00 + '%' "></span>
                                            </div>
                                            <div class="ov-card highlight">
                                                <span class="card-label">PG/S</span>
                                                <span class="card-value" data-bind="text: overviewData.viewsPerSessionLoggedIn ? Number(overviewData.viewsPerSessionLoggedIn).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0.00"></span>
                                            </div>
                                        </div>
                                        <div class="card-row">
                                            <div class="ov-card highlight">
                                                <span class="card-label">Views</span>
                                                <span class="card-value" data-bind="text: overviewData.viewsLoggedInPercentage ? Number(overviewData.viewsLoggedInPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : 0.00 + '%' "></span>
                                            </div>
                                            <div class="ov-card highlight">
                                                <span class="card-label">Visits</span>
                                                <span class="card-value" data-bind="text: overviewData.visitsLoggedInPercentage ? Number(overviewData.visitsLoggedInPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : 0.00 + '%'"></span>
                                            </div>
                                        </div>
                                        <div class="card-row card-row-3">
                                            <div class="ov-card highlight">
                                                <span class="card-label">AVG SPEED</span>
                                                <span class="card-value" data-bind="text: Number(overviewData.avgConnectionSpeedLoggedIn).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                            </div>
                                            <div class="ov-card highlight">
                                                <span class="card-label">Scroll Depth %</span>
                                                <span class="card-value" data-bind="text: Number(overviewData.avgViewEngagedDepthPercentageLoggedIn).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' "></span>
                                            </div>
                                            <div class="ov-card highlight">
                                                <span class="card-label">AVD (MM:SS)</span>
                                                <span class="card-value" data-bind="text: overviewData.avgViewEngagedSecondsLoggedIn"></span>
                                            </div>
                                        </div>
                                    <!-- /ko -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="page-header">
                        <button data-bind="click: toggleOpenVariableFilters" class="button-default mobile-filters icon i-filters variable-filters-btn-js-only" type="button"></button>
                    </div>

                    <div class="w-justify block-filters side-block-filters variable-filters-js-only" data-bind="css: isVariableFiltersOpen() ? 'is-open' : ''"> <!-- is-open -->
                        <div class="w-right flex-all block-default">
                            <div class="w-justify full-width">
                                <div class="w-left ">
                                    <div class="sidebar-default-header">
                                        <span class="label-default sidebar-default-header icon i-filters">Filters</span>
                                        <button data-bind="click: toggleOpenVariableFilters" type="button" class="btn-close-default icon i-close"><span></span></button>
                                    </div>
                                    <div>
                                        ${this.metricFilter.getHtmlBuild()}
                                    </div>
                                    <div>
                                        ${this.dimensionFilter.getHtmlBuild()}
                                    </div>
                                </div>
                                <div class="w-right">
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="w-metrics section-metrics">

                        <div class="metrics-body">
                            <div class="metric-item" data-bind="visible: dimensionSwitch() == 'device'">
                                <table class="section-device list-results w-card-table" data-bind="visible: dimensionSwitch() == 'device'"
                                    <thead>
                                        <tr class="list-header-row">
                                            <th colspan="2"><span>Device</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko foreach: deviceData -->
                                        <tr>
                                            <td data-bind="text: $data.dimension"></td>
                                            <td class="align-right">
                                                <span data-bind="text: Number($data.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                <span class="grey" data-bind="text: ' (' + Number($parents[0].getComp($data.value)).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' + ')'"></span>
                                            </td>
                                        </tr>
                                        <!-- /ko -->
                                    </tbody>
                                </table>
                            </div>
                            <div class="metric-item" data-bind="visible: dimensionSwitch() == 'os'">
                                <table class="section-os list-results w-card-table" data-bind="visible: dimensionSwitch() == 'os'">
                                    <thead>
                                        <tr class="list-header-row">
                                            <th colspan="2"><span>OS</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko foreach: osData -->
                                        <tr>
                                            <td data-bind="text: $data.dimension"></td>
                                            <td class="align-right">
                                                <span data-bind="text: Number($data.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                <span class="grey" data-bind="text: ' (' + Number($parents[0].getComp($data.value)).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' + ')'"></span>
                                            </td>
                                        </tr>
                                        <!-- /ko -->
                                    </tbody>
                                </table>
                            </div>
                            <div class="metric-item" data-bind="visible: dimensionSwitch() == 'browser'">
                                <table class="section-browser list-results w-card-table" data-bind="visible: dimensionSwitch() == 'browser'">
                                    <thead>
                                        <tr class="list-header-row">
                                            <th colspan="2"><span>Browser</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko foreach: browserData -->
                                        <tr>
                                            <td data-bind="text: $data.dimension"></td>
                                            <td class="align-right">
                                                <span data-bind="text: Number($data.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                <span class="grey" data-bind="text: ' (' + Number($parents[0].getComp($data.value)).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' + ')'"></span>
                                            </td>
                                        </tr>
                                        <!-- /ko -->
                                    </tbody>
                                </table>
                            </div>
                            <div class="metric-item" data-bind="visible: dimensionSwitch() == 'geo'">
                                <table class="section-geo list-results w-card-table" data-bind="visible: dimensionSwitch() == 'geo'">
                                    <thead>
                                        <tr class="list-header-row">
                                            <th colspan="2"><span>Geo</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko foreach: geoData -->
                                        <tr>
                                            <td data-bind="text: $data.dimension"></td>
                                            <td class="align-right">
                                                <span data-bind="text: Number($data.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                <span class="grey" data-bind="text: ' (' + Number($parents[0].getComp($data.value)).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' + ')'"></span>
                                            </td>
                                        </tr>
                                        <!-- /ko -->
                                    </tbody>
                                </table>
                            </div>
                            <div class="metric-item" data-bind="visible: dimensionSwitch() == 'source'">
                                <table class="section-source list-results w-card-table" data-bind="visible: dimensionSwitch() == 'source'">
                                    <thead>
                                        <tr class="list-header-row">
                                            <th colspan="2"><span>source</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko foreach: sourceData -->
                                        <tr>
                                            <td data-bind="text: $data.dimension"></td>
                                            <td class="align-right">
                                                <span data-bind="text: Number($data.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                <span class="grey" data-bind="text: ' (' + Number($parents[0].getComp($data.value)).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' + ')'"></span>
                                            </td>
                                        </tr>
                                        <!-- /ko -->
                                    </tbody>
                                </table>
                            </div>
                            <div class="metric-item landing-pages" >
                                <table class="section-landingPage list-results w-card-table">
                                    <thead>
                                        <tr class="list-header-row">
                                            <th colspan="3"><span>landing page</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko foreach: landingPageData -->
                                        <tr>
                                            <td class="brand" data-bind="text: $data.brand"></td>
                                            <td>
                                                <span class="page" data-bind="text: $data.permalink"></span>
                                            </td>
                                            <td class="views">
                                                <span data-bind="text: Number($data[$parents[0].metricSwitch()]).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                <span class="grey" data-bind="text: ' (' + Number($parents[0].getComp($data[$parents[0].metricSwitch()])).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' + ')'"></span>
                                            </td>
                                        </tr>
                                        <!-- /ko -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('brandDashboard');

        this.brandFilter = new filterSingle_multiLevel_selector_template('brandFilter', this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel('Brand');
        this.brandFilter.setAllOptionsText('Network');
        this.brandFilter.setHasLogo(true);
        this.brandFilter.setDefaultLogo(vnApp_sentinelbi.BRAND_DEFAULT_ICON_PATH);        

        let date = new Date();
        date.setHours(0,0,0,0);
        date.setDate(date.getDate() - 1);

        this.dateRangeFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateRangeFilter.setStartPickerId('dateRangeStartDatePicker');
        this.dateRangeFilter.setEndPickerId('dateRangeEndDatePicker');
        this.dateRangeFilter.setDateRange(date, date);

        this.metricFilter = new filterSingle_multiLevel_selector_template('metricFilter', this.getTemplateViewModel(), this.caller);
        this.metricFilter.setLabel('Metric');

        this.dimensionFilter = new filterSingle_multiLevel_selector_template('dimensionFilter', this.getTemplateViewModel(), this.caller);
        this.dimensionFilter.setLabel('Dimension');

        window.addEventListener('click', event => {

            const reportFilters = document.querySelector('.report-filters-js-only');
            const reportFiltersBtn = document.querySelector('.report-filters-btn-js-only');
            const variableFilters = document.querySelector('.variable-filters-js-only');
            const variableFiltersBtn = document.querySelector('.variable-filters-btn-js-only');

            if (!reportFilters?.contains(event.target as Element) && !reportFiltersBtn?.contains(event.target as Element)){
                this.getTemplateViewModel().isReportFiltersOpen(false);
            }

            if (!variableFilters?.contains(event.target as Element) && !variableFiltersBtn?.contains(event.target as Element)){
                this.getTemplateViewModel().isVariableFiltersOpen(false);
            }
        })
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'brandDashboard_template';
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(): Object{

        let self = this;

        return {
            isPresetVisible: ko.observable(false),
            metricSwitch: ko.observable(''),
            mobileDateBtnSwitch: ko.observable('yesterday'),
            dimensionSwitch: ko.observable(''),
            overviewData: ko.observable({'views':0, 'visits':0, 'sessions':0, 'viewEngagedSeconds':0, 'viewEngagedDepthPercentages':0, 'connectionSpeeds':0, 'viewsPerSession':0, 'avgViewEngagedSeconds':0, 'avgViewEngagedDepthPercentage':0, 'avgConnectionSpeed':0, 'viewsLoggedIn':0, 'visitsLoggedIn':0, 'sessionsLoggedIn':0, 'viewEngagedSecondsLoggedIn':0, 'viewEngagedDepthPercentagesLoggedIn':0, 'connectionSpeedsLoggedIn':0, 'viewsPerSessionLoggedIn':0, 'avgViewEngagedSecondsLoggedIn':0, 'avgViewEngagedDepthPercentageLoggedIn':0, 'avgConnectionSpeedLoggedIn':0, 'viewsLoggedInPercentage':0, 'visitsLoggedInPercentage':0, 'sessionsLoggedInPercentage':0, 'viewEngagedSecondsLoggedInPercentage':0, 'viewEngagedDepthPercentagesLoggedInPercentage':0, 'connectionSpeedsLoggedInPercentage':0, 'viewsPerSessionLoggedInPercentage':0, 'avgViewEngagedSecondsLoggedInPercentage':0, 'avgViewEngagedDepthPercentageLoggedInPercentage':0, 'avgConnectionSpeedLoggedInPercentage':0}),
            deviceData: ko.observableArray([]),
            osData: ko.observableArray([]),
            browserData: ko.observableArray([]),
            geoData: ko.observableArray([]),
            sourceData: ko.observableArray([]),
            landingPageData: ko.observableArray([]),
            isReportFiltersOpen: ko.observable(false),
            isVariableFiltersOpen: ko.observable(false),
            toggleOpenReportFilters: function(data){

                self.toggleOpenReportFilters();
            },
            toggleOpenVariableFilters: function(data){

                self.toggleOpenVariableFilters();
            },
            onMouseOverPreset : function () {
                self.onMouseOverPreset();
            },
            onMouseOutPreset : function () {
                self.onMouseOutPreset();
            },
            onMobileDateBtnSwitch: function(data, event){

                self.onMobileDateBtnSwitch(data, event);
            },
            getComp: function(data){

                return self.getComp(data);
            },
        }
    }

    public toggleOpenReportFilters(){
        const bool = !this.getTemplateViewModel().isReportFiltersOpen();
        this.getTemplateViewModel().isReportFiltersOpen(bool);
    }

    public toggleOpenVariableFilters(){
        const bool = !this.getTemplateViewModel().isVariableFiltersOpen();
        this.getTemplateViewModel().isVariableFiltersOpen(bool);
    }

    /**
     * @inheritDoc
     */
    public getViewModelForRequest(): Object{

        return {
            filters: {
                selectedBrand: this.brandFilter.getTemplateViewModel().selectedOption(),
                selectedBrandText: this.brandFilter.getTemplateViewModel().selectedOptionText(),
                dateFilterType: this.getTemplateViewModel().dateRangeFilter.selectedFilter(),
                selectedMonth: this.getTemplateViewModel().dateRangeFilter.selectedMonth(),
                selectedWeek: this.getTemplateViewModel().dateRangeFilter.selectedWeek(),
                startDate: this.getTemplateViewModel().dateRangeFilter.startDate(),
                endDate: this.getTemplateViewModel().dateRangeFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateRangeFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateRangeFilter.toRange(),
                mobileDateBtnSwitch: this.getTemplateViewModel().mobileDateBtnSwitch(),
                metricSwitch: this.metricFilter.getTemplateViewModel().selectedOption(),
                metricSwitchText: this.metricFilter.getTemplateViewModel().selectedOptionText(),
                dimensionSwitch: this.dimensionFilter.getTemplateViewModel().selectedOption(),
                dimensionSwitchText: this.dimensionFilter.getTemplateViewModel().selectedOptionText(),
            },
        };
    }

    /**
     * Build the date Picker calendar.
     */
    public buildDatePickerCalendar(){

        this.dateRangeFilter.buildCalendar();
    }

    public getComp(data){

        let metric = this.metricFilter.getTemplateViewModel().selectedOption();
        let overviewData = this.getTemplateViewModel().overviewData()
        let comp = overviewData[metric];


        return (comp > 0) ? (data / comp) * 100 : 0;
    }

    public setMetricFilterItems() {

        const options = this.metricValues;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.metricFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.metricFilter.setSelectedOption(filterItems[2].id);
        this.metricFilter.setSelectedOptionText(filterItems[2].name);
        this.getTemplateViewModel().metricSwitch(filterItems[2].id);
    }

    public setDimensionFilterItems() {

        const options = this.dimensionValues;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.dimensionFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.dimensionFilter.setSelectedOption(filterItems[0].id);
        this.dimensionFilter.setSelectedOptionText(filterItems[0].name);
        this.getTemplateViewModel().dimensionSwitch(filterItems[0].id);
    }

    public onMetricSwitch(){

        this.getTemplateViewModel().metricSwitch(this.metricFilter.getTemplateViewModel().selectedOption());
    }

    public onDimensionSwitch(){

        this.getTemplateViewModel().dimensionSwitch(this.dimensionFilter.getTemplateViewModel().selectedOption());
    }

    public onMobileDateBtnSwitch(data, event){

        this.getTemplateViewModel().mobileDateBtnSwitch(data);
        let yesterday = new Date();
        yesterday.setHours(0,0,0,0);
        yesterday.setDate(yesterday.getDate() - 1);

        if (data == "yesterday") {

            this.dateRangeFilter.setDateRange(yesterday, yesterday);
        }else if (data == "mtd") {

            let firstOfMonth = new Date(yesterday.getFullYear(), yesterday.getMonth(), 1);

            // if it is the first day of the month, we display data from the last month
            if (yesterday.getTime() === firstOfMonth.getTime()) {
                firstOfMonth = new Date(yesterday.getFullYear(), yesterday.getMonth() - 1, 1);
            }
            this.dateRangeFilter.setDateRange(firstOfMonth, yesterday);
        }else if (data == "wtd") {

            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            var lastSunday = new Date(today.setDate(today.getDate()-today.getDay()));

            this.dateRangeFilter.setDateRange(lastSunday, yesterday);
        }else if(data == "last-week") {

            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            var lastSunday = new Date(today.setDate(today.getDate()-today.getDay()));
            var lastSaturday = new Date(today.setDate(lastSunday.getDate() - 1));
            var lastWeekStart = new Date(today.setDate(lastSaturday.getDate() - 6));
            this.dateRangeFilter.setDateRange(lastWeekStart, lastSaturday);
        }

        this.caller.getReportData();
    }

    public setMobileDateBtnSwitch(value): void{

        this.getTemplateViewModel().mobileDateBtnSwitch(value);
    }

    public setBrandFilterItems(portfolios): void{

        let groups = [];

        this.brandFilter.setIncludeAllOptions(true);

        for(let portfolio of portfolios){

            let subGroups = [];

            let portfolioItem = {"id": portfolio.id, "name": portfolio.name, "cssClasses": portfolio.logo, "type": 'portfolio'};

            if (!(typeof(portfolio.disabled) !== 'undefined' && portfolio.disabled === true)){

                groups.push(portfolioItem);

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};

                    subGroups.push(brandItem);
                }
                portfolioItem['subGroups'] = subGroups;
            }else{

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};
                    groups.push(brandItem);

                }
            }

        }

        // call setGroups function

        this.brandFilter.setGroups(groups);
        //this.brandFilter.setSelectedOption('all');
    }

    protected onMouseOverPreset(){

        this.getTemplateViewModel().isPresetVisible(true);
    }

    protected onMouseOutPreset(){

        this.getTemplateViewModel().isPresetVisible(false);
    }

    public updateData(type, data) {

        switch (type) {
            case 'overview':
                this.getTemplateViewModel().overviewData(data);
                break;
            case 'device':
                this.getTemplateViewModel().deviceData(data);
                break;
            case 'os':
                this.getTemplateViewModel().osData(data);
                break;
            case 'browser':
                this.getTemplateViewModel().browserData(data);
                break;
            case 'geo':
                this.getTemplateViewModel().geoData(data);
                break;
            case 'source':
                this.getTemplateViewModel().sourceData(data);
                break;
            case 'landingPage':
                this.getTemplateViewModel().landingPageData(data);
                break;
        }
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['selectedBrand'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOption(params['selectedBrand']);
        }

        if(typeof params['selectedBrandText'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOptionText(params['selectedBrandText']);
        }

        this.presetFilter.setDates(this.dateRangeFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange'], params['selectedMonth'], params['selectedWeek']);

        if(typeof params['metricSwitch'] !== 'undefined'){

            this.metricFilter.setSelectedOption(params['metricSwitch']);
            this.getTemplateViewModel().metricSwitch(params['metricSwitch']);
        }

        if(typeof params['metricSwitchText'] !== 'undefined'){

            this.metricFilter.setSelectedOptionText(params['metricSwitchText']);
        }

        if(typeof params['mobileDateBtnSwitch'] !== 'undefined'){

            this.getTemplateViewModel().mobileDateBtnSwitch(params['mobileDateBtnSwitch']);
        }

        if(typeof params['dimensionSwitch'] !== 'undefined'){

            this.getTemplateViewModel().dimensionSwitch(params['dimensionSwitch']);
        }
    }

    private isDateDifferenceWithinDays(startDate, endDate, numDays) {

        const dateA = new Date(startDate);
        const dateB = new Date(endDate);

        const diffInMs = Math.abs(dateA.getTime() - dateB.getTime());
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        return (diffInDays + 1) <= numDays;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/brandDashboard_template.ts